import React, { Component, useEffect } from "react";
import './mainHeaderStyle.css';
import Logo from '../../assets/Icons/Logo.png';
import data from "../HomeData.json";


export const MainHeaderr = (props) =>{

    var active = props.active;
    var shadows = props.shadows;
    var activeBlog = props.activeBlog;

    useEffect(()=>{
        document.addEventListener("scroll" , () =>{
            headerEvent();
        });
    });

    // Header Function
    const headerEvent = () =>{
        var WindowScrolly = window.scrollY;
        var WindowHeight = window.innerHeight;
        var mainHeadermainBody = document.getElementById("mainHeadermainBody"); 

        mainHeadermainBody?.classList.remove("mainHeadermainBody");
        mainHeadermainBody?.classList.add("mainHeadermainBodyScroll");

        if(WindowScrolly > WindowHeight - 450){
            mainHeadermainBody.style.transition = "0.5s";
            mainHeadermainBody?.classList.add("mainHeadermainBodyScroll2");
            setTimeout(() => {
                mainHeadermainBody.style.transition = "0s";
            }, 500);
        }else{
            if (WindowScrolly > 200) {
                mainHeadermainBody.style.transition = "0.5s";
            }else{
                mainHeadermainBody.style.transition = "0s";
            }
            mainHeadermainBody?.classList.remove("mainHeadermainBodyScroll2");
            setTimeout(() => {
                mainHeadermainBody.style.transition = "0s";
            }, 500);
        }
        if( WindowScrolly < 100 ){
            mainHeadermainBody.style.transition = "0s";
            mainHeadermainBody?.classList.remove("mainHeadermainBodyScroll");
            mainHeadermainBody?.classList.add("mainHeadermainBody");
        }
    }


    const CloseHeader = () =>{
        let MenuMobileMainScreen = document.getElementById("MenuMobileMainScreen");
        let MenuMobileMainContainer = document.getElementById("MenuMobileMainContainer");

        MenuMobileMainScreen.classList.toggle("MenuMobileMainScreenActive");
        MenuMobileMainContainer.classList.toggle("MenuMobileMainContainerActive");
    }


    const toTextEditFunction = (event) =>{
        if (localStorage.getItem("isLogged") == "true") {
            let toTextEdit = event.target;
            let Oldtext = toTextEdit.innerText;
            let Classes = toTextEdit.classList;
            let width = toTextEdit.getBoundingClientRect().width;
            let height = toTextEdit.getBoundingClientRect().height;
            let id = toTextEdit.linke;

            console.log(id);

            toTextEdit.innerHTML = "";
            let textArea = document.createElement("textarea");
            toTextEdit.appendChild(textArea);
            textArea.classList.add("TextEditArea");

            for (let i = 0; i < Classes.length; i++) {
                textArea.classList.add(Classes[i]);
            }

            textArea.focus();
            textArea.value = Oldtext;

            textArea.style.width = width + 20 + "px";
            textArea.style.height = height + 10 + "px";

            toTextEdit.addEventListener("focusout" , ()=> {
                if ( textArea.value.length > 0) {
                    toTextEdit.innerHTML = textArea.value;
                    data[id] = textArea.value;
                }else{
                    //this.ShowErrorAlert("Sory you can not save empty!" , 3000);
                }
            });

            
            toTextEdit.addEventListener("keydown" , ()=> {
                textArea.style.width = "max-content";
                textArea.style.height = "max-content";
            });
        }
    }



    return(
        <div>

        {/* MENU MOBILE */ }
        <div className={"MenuMobileMainScreen d-flex flex-row-reverse"} id="MenuMobileMainScreen">
                <div className="MenuMobileMainContainer" id="MenuMobileMainContainer">
                    <div className="HeadMenuMobile d-flex justify-content-between align-items-center">
                        <span className="MenuTitle">Menu</span>
                        <i className="fas fa-times CloseIconMenu" onClick={CloseHeader}></i>
                    </div>

                    <div className="BodyMenuMobile">
                        <ul className="NavUlMobile d-flex flex-column align-items-center justify-content-center">
                        <a href="/#Home"><li className="NavListItem NavListItemMobile" onClick={CloseHeader}>Home</li></a>
                            <a href="/#About"><li className="NavListItem NavListItemMobile" onClick={CloseHeader}>Über mich</li></a> 
                            <a href="/#Skills"><li className="NavListItem NavListItemMobile" onClick={CloseHeader}>Skills</li></a>
                            <a href="/#Blog"><li className={activeBlog + " NavListItem NavListItemMobile"} onClick={CloseHeader}>Blog</li></a>
                            <a href="/#Contact"><li className="NavListItem NavListItemMobile" onClick={CloseHeader}>Kontakt</li></a>
                            <a href="/cv"><li className={ active + " NavListItem NavListItemMobile"}  onClick={CloseHeader}>Lebenslauf</li></a>
                        </ul>
                    </div>
                </div>
                <div className="balckSide" onClick={CloseHeader}>
                </div>
            </div>

        <div className={ " mainHeadermainBody d-flex justify-content-center"} id="mainHeadermainBody" style={props.style}>
            <div className="HeaderContainer d-flex justify-content-between align-items-center" id="HeaderContainer">

                <div className="logoContainer" id="logoContainer">
                    <a href="/"> <img src={Logo} alt="Logo" className="LogoIcon" id="LogoIcon"/> </a>
                </div>

                <nav className="headerNav" id="headerNav">
                    <ul className="NavUl d-flex justify-content-center" id="NavUl">
                        <a href="/#Home"><li className="NavListItem" >Home</li></a>
                        <a href="/#About"><li className="NavListItem">Über mich</li></a>
                        <a href="/#Skills"><li className="NavListItem">Skills</li></a>
                        <a href="/#Blog"><li className={activeBlog + " NavListItem"}>Blog</li></a>
                        <a href="/#Contact"><li className="NavListItem">Kontakt</li></a>
                        <a href="/cv"><li className={ active + " NavListItem"}>Lebenslauf</li></a>
                    </ul>
                </nav>

                <div className="NavSmallScreenIconContainer" id="MenuIcon" onClick={CloseHeader}>
                    <div className="NavSmallScreenIcon d-flex justify-content-between align-items-center"><i class="fas fa-bars MenuIcon"></i> <div class="MenuLablel">Menu</div> </div>
                </div>
            </div>
        </div>

        </div>
    );






}

